import React from 'react';
import TermSelect from './TermSelect';
import LocationFilter from './LocationFilter';
import SubjectFilter from './SubjectFilter';
import MiscPopup from './MiscPopup';
import SessionSelect from './SessionSelect';

class FilterPanel extends React.Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.clearDates = this.clearDates.bind(this);
        this.refDtFirst = React.createRef();
        this.refDtSecond = React.createRef();
    }

    handleChange(e) {
        this.props.onChange(e);
    }

    clearDates() {
        this.refDtFirst.current.value = null;
        this.refDtSecond.current.value = null;
        this.props.clearDates();
    }

    render() {
        let compareButton = null;
        if (this.props.status !== "SHOW_COMPARES" && this.props.compares.length === 1) {
            compareButton = <button className="btn btn-light mt-2 mb-2 btn-block" ><i className="fas fa-list"></i>&nbsp;Add 1 more to compare</button>;
        } else if (this.props.status !== "SHOW_COMPARES" && this.props.compares.length > 1) {
            compareButton = <button onClick={this.props.showCompares} className="btn btn-secondary mt-2 mb-2 btn-block" ><i className="fas fa-list"></i>&nbsp;Compare {this.props.compares.length} classes</button>;
        } else if (this.props.status === "SHOW_COMPARES") {
            compareButton = <button onClick={this.props.showResults} className="btn btn-secondary mt-2 mb-2 btn-block" ><i className="fas fa-backspace"></i>&nbsp;Back to Results</button>;
        }

        if (this.props.status !== "CLASSES_FOUND" && this.props.status !== "NO_CLASSES_FOUND") {
            return (
                <>
                    <a href="http://my.umgc.edu/" className="btn btn-primary mt-2 mb-2 btn-block" ><i className="fas fa-sign-in-alt"></i>&nbsp;Log in to register</a>
                    {compareButton}
                </>
            );
        } else {
            return (
                <>
                    <a href="http://my.umgc.edu/" className="btn btn-primary mt-2 mb-2 btn-block" ><i className="fas fa-sign-in-alt"></i>&nbsp;Log in to register</a>
                    {compareButton}
                    <div className="card-body">
                        {/*
                        
                        Commented out instead of removed because it will likely be requested in the future.

                        (this.props.instructionModeFilter.includes("ONSITE") || this.props.instructionModeFilter.includes("REMOTE")) ?
                                        <><strong>Region</strong>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="radioArea" id="radioEurope" value="EUROPE" checked={this.props.area === "EUROPE"} onChange={this.handleChange} />
                                                <label className="form-check-label" htmlFor="radioEurope">Europe</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="radioArea" id="radioDownrange" value="DOWNRANGE" checked={this.props.area === "DOWNRANGE"} onChange={this.handleChange} />
                                                <label className="form-check-label" htmlFor="radioDownrange">Middle East & Africa</label>
                                            </div>
                                            <br /></>
            : null*/}
                        <strong>Region</strong>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="radioArea" id="radioEurope" value="EUROPE" checked={this.props.area === "EUROPE"} onChange={this.handleChange} />
                            <label className="form-check-label" htmlFor="radioEurope">Europe</label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="radioArea" id="radioDownrange" value="DOWNRANGE" checked={this.props.area === "DOWNRANGE"} onChange={this.handleChange} />
                            <label className="form-check-label" htmlFor="radioDownrange">Middle East & Africa</label>
                        </div>
                        <br />

                        <strong>Academic Career</strong>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="radioAcadCareer" id="radioUndergrad" value="UGRD" checked={this.props.careerFilter.includes('UGRD')} onChange={this.handleChange} />
                            <label className="form-check-label" htmlFor="radioUndergrad">Undergraduate</label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="radioAcadCareer" id="radioGrad" value="GRAD" checked={!this.props.careerFilter.includes('UGRD')} onChange={this.handleChange} />
                            <label className="form-check-label" htmlFor="radioGrad">Graduate</label>
                        </div>
                        <br />
                        <strong>Term</strong><br />
                        <select id="selectTerm" className="form-select" aria-label="Term" style={{ width: "100%" }} onChange={this.handleChange} value={this.props.termFilter}>
                            {this.props.terms.map((t) => {
                                return <TermSelect key={t.STRM} term={t} />
                            })}
                        </select>






                        {/* Commented out for student facing version */}
                        {/* <br /><br />
                        <strong>Session</strong><br />
                        <select id="selectSession" className="form-select" aria-label="Session" style={{ width: "100%" }} onChange={this.handleChange} value={this.props.sessionFilter}>
                            <option value="">All
                            </option>
                            {this.props.sessions.map((s) => {
                                if (s.STRM === this.props.termFilter && this.props.careerFilter.includes(s.ACAD_CAREER)) {
                                    return <SessionSelect key={s.SESSION_CODE} session={s} />
                                } else {
                                    return <SessionSelect key={s.SESSION_CODE} session={s} />
                                }
                            })}
                        </select>
 */}




                        <br /><br />
                        <strong>Format</strong>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="chkFormat" id="chkOnsite" value="ONSITE" checked={this.props.instructionModeFilter.includes("ONSITE")} onChange={this.handleChange} />
                            <label className="form-check-label" htmlFor="chkOnsite">On-site</label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="chkFormat" id="chkFieldStudy" value="FIELDSTUDY" checked={this.props.instructionModeFilter.includes("FIELDSTUDY")} onChange={this.handleChange} />
                            <label className="form-check-label" htmlFor="chkFieldStudy">Field Study</label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="chkFormat" id="chkVirtual" value="VIRTUAL" checked={this.props.instructionModeFilter.includes("VIRTUAL")} onChange={this.handleChange} />
                            <label className="form-check-label" htmlFor="chkVirtual">Virtual <MiscPopup message="Online course meets via Zoom" /></label>
                        </div>
                        {/* Remote on-site is only a valid option for Summer 21 and prior. Don't show the option after Summer '21 */}
                        {parseInt(this.props.termFilter) < 2218 ?
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="chkFormat" id="chkRemote" value="REMOTE" checked={this.props.instructionModeFilter.includes("REMOTE")} onChange={this.handleChange} />
                                <label className="form-check-label" htmlFor="chkRemote">Remote On-site <MiscPopup message="Counted as on-site but meets remotely via Zoom" /></label>
                            </div>
                            : null}
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="chkFormat" id="chkOnline" value="ONLINE" checked={this.props.instructionModeFilter.includes("ONLINE")} onChange={this.handleChange} />
                            <label className="form-check-label" htmlFor="chkOnline">Online</label>
                        </div>
                    </div>
                    <div id="accordion">
                        {this.props.instructionModeFilter.includes("ONSITE") ? <>
                            <div className="card">
                                <div className="card-header" id="headingTwo">
                                    <h5 className="mb-0">
                                        <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            <i className="fas fa-compass"></i>&nbsp;Location
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                    <div className="card-body">
                                        {this.props.instructionModeFilter.includes("ONSITE") ?
                                            <LocationFilter locationCheckboxes={this.props.locationCheckboxes} onChange={this.handleChange} checkAllLocations={this.props.checkAllLocations} /> : null}


                                        {/* 6/26/23 YO: Workaround!! Delete below when section was created for new locations 
                                        Keeping those if they still wants to show locations eventhough have no classes */}

                                        {/* ///////////////// */}


                                        {/* {this.props.area === "EUROPE" ? <>
                                            <ul style={{ marginTop: -15 }}>

                                                <strong>Romania</strong><br></br>
                                                <li> <input type="checkbox" defaultChecked />
                                                    <label style={{ display: "contents" }} className="form-check-label">&nbsp;&nbsp;Mihail Kogălniceanu Air Base (MKAB)</label>
                                                </li>
                                            </ul>
                                        </>
                                            : <> */}
                                                {/* <ul style={{marginTop:-15}}>
                       <strong>Saudi Arabia</strong><br></br> 
                       <li><input  type="checkbox" defaultChecked/>
                        <label style={{display:"contents"}} className="form-check-label">  &nbsp;&nbsp;Prince Sultan Air Base (PSAB)</label><br></br> </li>  
                        </ul> */}


                                            {/* </>} */}
                                        {/* ///////////////// */}

                                    </div>
                                </div>
                            </div>
                        </> : null}


                        <div className="card">
                            <div className="card-header" id="headingThree">
                                <h5 className="mb-0">
                                    <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        <i className="fas fa-graduation-cap"></i>&nbsp;Subject
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                <div className="card-body">
                                    <SubjectFilter subjectCheckboxes={this.props.subjectCheckboxes} onChange={this.handleChange} checkAllSubjects={this.props.checkAllSubjects} careerFilter={this.props.careerFilter} />
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-header" id="headingAdditionalFilters">
                                <h5 className="mb-0">
                                    <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseAdditionalFilters" aria-expanded="false" aria-controls="collapseAdditionalFilters">
                                        <i className="fas fa-compass"></i>&nbsp;Additional Filters
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseAdditionalFilters" className="collapse" aria-labelledby="headingAdditionalFilters" data-parent="#accordion">
                                <div className="card-body">
                                    <div>
                                        <input type="checkbox" id="chk1Credit" name="chk1Credit" checked={this.props.oneCreditOnly} onChange={this.handleChange} />
                                        <label htmlFor="chk1Credit">&nbsp;1-CH Class Only</label>
                                    </div>

                                    <div>
                                        <input type="checkbox" id="chkClassesStarted" name="chkClassesStarted" checked={this.props.showClassesStarted} onChange={this.handleChange} />
                                        <label htmlFor="chkClassesStarted">&nbsp;Include classes in progress</label>
                                    </div>
                                    
                                     {/*Courses with Newly Added */}
                                     <div>
                                        <input type="checkbox" id="chkNewlyAdded" name="chkNewlyAdded" checked={this.props.showNewlyAdded} onChange={this.handleChange} />
                                        <label htmlFor="chkNewlyAdded">&nbsp;Newly Added Classes</label>
                                    </div>
                                    <div>
                                        <input type="checkbox" id="chkIntersession" name="chkIntersession" checked={this.props.showIntersession} onChange={this.handleChange} />
                                        <label htmlFor="chkIntersession">&nbsp;Intersession</label>
                                    </div>

                                   
                                    <br />
                                    <strong>Start date</strong><button className="btn btn-secondary btn-sm ml-1" onClick={this.clearDates}>Clear</button><br />
                                    <label htmlFor="dtFirst">between</label>
                                    <input type="date" id="dtFirst" name="dtFirst" style={{ width: "100%" }} onChange={this.handleChange} ref={this.refDtFirst} value={this.props.startDateFirstFilter} />
                                    <br />
                                    <label htmlFor="dtSecond">and</label>
                                    <br />
                                    <input type="date" id="dtSecond" name="dtSecond" style={{ width: "100%" }} onChange={this.handleChange} ref={this.refDtSecond} value={this.props.startDateSecondFilter} />
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-header" id="headingFive">
                                <h5 className="mb-0">
                                    <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                        <i className="fas fa-search"></i>&nbsp;Search
                                    </button>
                                </h5>
                            </div>
                            <div >
                                <div className="card-body">
                                    <input type="text" id="search" name="search" onChange={this.handleChange} defaultValue={this.props.searchFilter} />
                                    <div>
                                        <input type="checkbox" id="chkIgnoreFilters" name="chkIgnoreFilters" onChange={this.handleChange} />
                                        <label htmlFor="chkIgnoreFilters">Ignore filters for search</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
    }
}

export default FilterPanel;
